import { render, staticRenderFns } from "./AddressView.vue?vue&type=template&id=0057985c&"
import script from "./AddressView.vue?vue&type=script&lang=js&"
export * from "./AddressView.vue?vue&type=script&lang=js&"
import style0 from "./AddressView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../fodchef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports